import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import constant from "./utils/constant";
import { changeAudio } from "./utils/audio";
import { changeVideo } from "./utils/video";
import "@lottiefiles/lottie-player";
import { SoundIcon } from "../../images/";
import { isVideoContent } from "../../utils/isVideoContent";

export const CircleWithIcon = (props) => {
  const {
    ChildComponent,
    backColor,
    diameter,
    classNames,
    onClickFunc,
    style: delegatedStyle,
    ...restProps
  } = props;
  const style = {
    backgroundColor: backColor,
    width: diameter,
    height: diameter,
    ...delegatedStyle,
  };
  return (
    <div
      className={`circle ${classNames}`}
      style={style}
      onClick={onClickFunc}
      {...restProps}
    >
      {<ChildComponent />}
    </div>
  );
};

CircleWithIcon.propTypes = {
  diameter: PropTypes.string,
  backColor: PropTypes.string,
  onClickFunc: PropTypes.func,
  classNames: PropTypes.string,
  ChildComponent: PropTypes.elementType.isRequired,
};

CircleWithIcon.defaultProps = {
  backColor: "transparent",
  onClickFunc: () => null,
  classNames: "",
};

export const CustomAudio = (props) => {
  const {
    classNames,
    src,
    duration,
    controls,
    autoPlay,
    setCurrentTime,
    clickedTextTime,
    wsConnected,
    activeIcon,
  } = props;
  const basic_audio = useRef(null);
  const iconNames = constant.ICON_NAMES;
  const [isVideo, setIsVideo] = useState(false);

  useEffect(() => {
    if (!src) return;
    setIsVideo(isVideoContent(src));
  }, [src]);


  useEffect(() => {
    const audio = basic_audio.current;
    let change_audio;
    if (isVideo) {
      change_audio = changeVideo(audio.id, duration, setCurrentTime);
    } else {
      change_audio = changeAudio(audio.id, duration, setCurrentTime);
    }
    return () => {
      change_audio?.();
    };
  },
    [isVideo, duration, setCurrentTime]
  );

  useEffect(() => {
    if (clickedTextTime !== null) {
      const audio = basic_audio.current;
      audio.currentTime = clickedTextTime;
    }
  }, [clickedTextTime]);

  const getMediaSrc = (src) => {
    const IS_DEV = window.location.hostname === "localhost";
    if (!src) return "";
    const newUrl = IS_DEV
      ? src.replace(/^https?:\/\/harf-sso\.roshan-ai\.ir/, "")
      : src;
    return newUrl;
  };

  return (
    <div className={classNames} dir='ltr'>
      <div className='audioplayer'>
        {isVideo ? (
          <video
            controls={false}
            className='video-player'
            preload='auto'
            id='basic-video'
            autoPlay={autoPlay}
            src={getMediaSrc(src)}
            ref={basic_audio}
            style={activeIcon === iconNames.MIC ? { display: "none" } : {}}
          />
        ) : (
          <audio
            style={{ width: 0, height: 0, visibility: "hidden" }}
            controls={controls}
            preload='auto'
            id='basic-audio'
            autoPlay={autoPlay}
            src={getMediaSrc(src)}
            ref={basic_audio}
          />
        )}
        <div
          className={"audioplayer-playpause" + (wsConnected ? " disable" : "")}
        >
          <span />
        </div>
        <div className='audioplayer-time audioplayer-time-current' />
        <div className='audioplayer-bar'>
          <div className='audioplayer-bar-loaded' style={{ width: "100%" }} />
          <div className='audioplayer-bar-played' style={{ width: "100%" }} />
        </div>
        <div className='audioplayer-time audioplayer-time-duration' />
        <div className='audioplayer-volume'>
          <div className='audioplayer-volume-button'>
            <span>
              <SoundIcon />
            </span>
          </div>
          <div className='audioplayer-volume-adjust'>
            <div>
              <div style={{ width: "100%" }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CustomAudio.propTypes = {
  src: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  clickedTextTime: PropTypes.number,
  setCurrentTime: PropTypes.func,
  controls: PropTypes.bool,
  autoPlay: PropTypes.bool,
  wsConnected: PropTypes.bool,
  classNames: PropTypes.string,
};

CustomAudio.defaultProps = {
  controls: true,
  autoPlay: false,
  clickedTextTime: null,
  wsConnected: false,
  classNames: "",
};
